import React from 'react';

import {Button as AuroraButton, BUTTON_VARIANT, View, ViewProperties} from '@lookiero/aurora';

import {style} from './ActionButtons.styles';

export const Button: React.FC<{children: React.ReactNode; testID?: string; onPress?: () => void}> = ({
  children,
  testID = '',
  onPress = () => undefined,
}) => (
  <AuroraButton variant={BUTTON_VARIANT.SECONDARY} small style={style.button} onPress={onPress} testID={testID}>
    {children}
  </AuroraButton>
);

type ButtonsContainerProps = ViewProperties;

export const ButtonsContainer: React.FC<ButtonsContainerProps> = ({children, ...props}) => (
  <View {...props}>{children}</View>
);
